// Modules
import styled from 'styled-components'
// Application
import DesktopIllustration from 'assets/new-desktop-illustration.svg'
import { Heading } from '@dasa-health/alma-react'
import breakPoint from 'theme/breakpoints'

export const StyledBanner = styled.aside`
    width: 30%;
    height: 100%;
    min-width: 357px;
    display: flex;
    align-items: end;
    position: relative;
    background: #fc503c;

    ${breakPoint.custom('1366px')} {
        min-width: 472px;
    }
`

export const CustomDesktopIllustration = styled.div`
    position: absolute;
    width: 271.51px;
    height: 589px;
    right: -60px;
    bottom: 0;
    background-image: url(${DesktopIllustration});
    background-size: cover;
    background-repeat: no-repeat;
    background-position-y: bottom;

    ${breakPoint.custom('1366px')} {
        width: 312px;
        height: 676px;
        right: -92px;
        background-position-y: 58px;
    }
`

export const CustomHeading: typeof Heading = styled(Heading)`
    color: #fff;
    max-width: 175px;
    line-height: 36.34px;
    margin-left: 24px;
    margin-bottom: 263px;
    font-size: 30.29px;

    ${breakPoint.custom('1366px')} {
        margin-left: 48px;
        margin-bottom: 218px;
        font-size: 40px;
        line-height: 48px;
    }
`
